export const downloadDocuments = {
  DOWNLOADED_DOCUMENT: 'downloadDocuments.downloadedDocument'
}
